import { getLocale } from "../runtime";

const da_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const en_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const es_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const fi_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const nb_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const sv_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const dkcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_dkcountryenglish(inputs)
	if (locale === "en") return en_dkcountryenglish(inputs)
	if (locale === "es") return es_dkcountryenglish(inputs)
	if (locale === "fi") return fi_dkcountryenglish(inputs)
	if (locale === "nb") return nb_dkcountryenglish(inputs)
	if (locale === "sv") return sv_dkcountryenglish(inputs)
	return "dkCountryEnglish";
};

export { dkcountryenglish as "dkCountryEnglish" };